import type { PostMediaSelection } from '@gr/core/content/posts/media-selection';

// POST-UC-14: медиа к публикации на странице поста.

/** Отметки после переключения одного медиа — в порядке поста. */
export function withPublish(post: PostMediaSelection, mediaId: string, publish: boolean): string[] {
  const excluded = new Set(post.excludedMediaIds);
  if (publish) excluded.delete(mediaId);
  else excluded.add(mediaId);
  return post.mediaIds.filter((id) => excluded.has(id));
}
